import { useEffect, useMemo, useState } from 'react'
import { initialQueryState } from '../../_metronic/helpers'
import { useQueryRequest } from './request'
//import { useQueryResponse } from './response'

//import Swal from 'sweetalert2'

/**
 * DocFilter component for filtering document data by KYC, DBT, and order.
 * - Renders checkboxes for No KYC, No DBT, and latest record options.
 * - Updates filter state and order using hooks and context.
 * - Applies filters and manages query state for document data.
 */
const DocFilter = () => {
    const { updateState, state } = useQueryRequest()
    // const { isLoading } = useQueryResponse()
    const [project_id] = useState(4); // fmc Project id
    const [noKyc, setNoKYC] = useState(null);
    const [noDbt, setNoDBT] = useState(null);

    const { order } = useMemo(() => state, [state])

    useEffect(() => {
        updateState({
            filter: { noDbt, noKyc, project_id },
            order: order,
            ...initialQueryState
        })

    }, [noDbt, noKyc])



    // const resetData = () => {
    //     updateState({ filter: undefined, order: order, document: 'all', ...initialQueryState })
    //     setToDate('')
    //     setFromDate('')
    //     setProjectId('')
    // }
    // const filterData = () => {
    //     updateState({
    //         filter: {  project_id },
    //         order: order,
    //         ...initialQueryState
    //     })

    // }
    // const setFilter = (type) => {
    //     const doc_type = 'all'
    //     if (type === 'nokyc') {
    //         doc_type
    //     }
    //     updateState({
    //         filter: { project_id, doc_type },
    //         order: order,
    //         // document: type || 'all',
    //         ...initialQueryState
    //     })

    // }
    const setOrderBy = (orderby) => {
        updateState({
            filter: { project_id },
            order: orderby,
            ...initialQueryState
        })
    }

    return (
        <>
            <div class="d-flex">
                <label class="form-check form-check-sm form-check-custom form-check-solid me-5">
                    <input onChange={(e) => setNoKYC(noKyc === 'NOKYC' ? null : 'NOKYC')} checked={noKyc === 'NOKYC'} class="form-check-input w-25px h-25px" type="checkbox" />
                    <span class="form-check-label fs-6 fw-semibold">No KYC</span>
                </label>
                <label class="form-check form-check-sm form-check-custom form-check-solid me-5">
                    <input onChange={(e) => setNoDBT(noDbt === 'NODBT' ? null : 'NODBT')} checked={noDbt === 'NODBT'} class="form-check-input w-25px h-25px" type="checkbox" />
                    <span class="form-check-label fs-6 fw-semibold">No DBT</span>
                </label>
                <label class="form-check form-check-sm form-check-custom form-check-solid me-5">
                    <input onChange={(e) => setOrderBy(order === 'desc' ? 'asc' : 'desc')} checked={order === 'desc'} class="form-check-input w-25px h-25px" type="checkbox" />
                    <span class="form-check-label fs-6 fw-semibold">Latest Record</span>
                </label>
            </div>
        </>
    )
}

export { DocFilter }
